// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import { TabbedViews, Form } from '@st-operations/uikit/src/v2/index.js'
import ListView from '_components/list-view/index.jsx'
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const LogFilePage = (props) => {
  useRetractSidebar()

  return (
    <div id="log-file-page">
      <EntityEditForm entities="log-files" id={props.match.params.id} resource="Log Files">
        {({ disabled, item, onChange, schema }) => (
          <TabbedViews key={item._id}>
            <Form
              title="Metadata"
              item={item}
              onChange={onChange}
              schema={schema}
              fields={[
                { name: 'name', disabled: true },
                { name: 'bucket' },
                { name: 'description' },
                { name: 'rotate_interval' },
              ]}
              disabled={disabled}
            />

            <ListView
              title="Data Sources"
              columns={[
                {
                  key: 'name',
                  link: '/data-sources/:_id',
                  name: 'Name',
                  sortable: true,
                },
                {
                  key: 'log_file.name',
                  link: '/log-files/:log_file._id',
                  name: 'Log File',
                },
                {
                  key: 'type',
                  name: 'Type',
                },
                {
                  key: 'description',
                  name: 'Description',
                },
              ]}
              queryString={{ 'log_file._id': item._id }}
              entities="data-sources"
              searchable={true}
              sort_key={'name'}
              stateful={false}
            />
          </TabbedViews>
        )}
      </EntityEditForm>
    </div>
  )
}

export default LogFilePage
